import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const itemMarginCellStyleId = 'wb-work-job-item-margin-cell-theme';

export const itemMarginCellBridgeStyles = {
  'item-margin-cell-renderer': {
    '--local-margin-cell-text': tokens.color.text.primary,
    // The same profit / loss colours as the board's footer.
    '--local-margin-cell-profit': tokens.color.text.successPrimary,
    '--local-margin-cell-loss': tokens.color.text.errorPrimary,
    '--local-margin-cell-font-size': tokens.font.size.textMdBase,
    '--local-margin-cell-line-height': tokens.lineHeight.textMd,
  },
};
